var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5468_3512)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 18,
    fill: "#ECF9FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7296 21.2705C34.9835 13.6878 29.8531 6.52439 22.2705 5.27046C14.6878 4.01652 7.52439 9.14693 6.27045 16.7296C5.01652 24.3122 10.1469 31.4756 17.7295 32.7296C25.3122 33.9835 32.4756 28.8531 33.7296 21.2705Z",
    fill: "url(#paint0_linear_5468_3512)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6458 19.0024C15.6065 19.0024 16.3853 18.2236 16.3853 17.2629C16.3853 16.3022 15.6065 15.5234 14.6458 15.5234C13.6851 15.5234 12.9062 16.3022 12.9062 17.2629C12.9062 18.2236 13.6851 19.0024 14.6458 19.0024Z",
    fill: "#2F6E79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3606 19.0024C26.3213 19.0024 27.1001 18.2236 27.1001 17.2629C27.1001 16.3022 26.3213 15.5234 25.3606 15.5234C24.3999 15.5234 23.6211 16.3022 23.6211 17.2629C23.6211 18.2236 24.3999 19.0024 25.3606 19.0024Z",
    fill: "#2F6E79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6445 22.0977C14.6445 25.0548 17.045 27.4553 20.0022 27.4553C22.9594 27.4553 25.3599 25.0548 25.3599 22.0977H14.6445Z",
    fill: "#2F6E79"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5468_3512",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5468_3512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5468_3512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5468_3512",
    x1: 22.2705,
    y1: 5.27046,
    x2: 17.7295,
    y2: 32.7296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51D2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FE3DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel0);
export default __webpack_public_path__ + "static/media/level0.b08f4794b8f27b1f9e3814e1249cde50.svg";
export { ForwardRef as ReactComponent };